import { erpApi } from "@/shared/axios/erp-api";
import { urlBackend } from "@/shared/constants";
import { handleAxiosError } from "@/shared/utils";
import { useUiStore } from "@/store/ui";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { isAxiosError } from "axios";

const { post } = erpApi();


/**
 * OBTENER BURO CREDITICIO
 * 
*/

interface IBuroCrediticio {
  identificacion: string
}

interface IDataBuroCreditos {
  puntaje_score: number;
  puntaje_score_sobreendeudamiento: number;
  puntaje_score_empresa: number;
  segmentacion: string;
  reportado: boolean;
}

export const useFetchBuroCredito = () => {
  const queryClient = useQueryClient();
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;

  const setConfirmDialogIsOpen = useUiStore.getState().setConfirmDialogIsOpen;
  const setConfirmDialog = useUiStore.getState().setConfirmDialog;

  return useMutation({
    mutationFn: getBuroCredito,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['obtener-datos-buro-credito'] });
    },
    onError: error => {
      if (isAxiosError(error)) {
        const respError: any = error.response?.data || {};
        if (respError.code == 504) {
          setConfirmDialogIsOpen(true);
          setConfirmDialog({
            isOpen: true,
            title: '¡Ocurrio un ERROR!',
            subtitle: 'Los servicios de EQUIFAX no están disponibles en este momento.',
            onClose() {
              setConfirmDialogIsOpen(false);
            },
            onConfirm() {
              setConfirmDialogIsOpen(false);
            }
          })

          return;
        }
      }

      handleAxiosError(error);
    },
    onSettled: () => {
      setIsGlobalLoading(false);
    }
  });
};

export const getBuroCredito = async (data: IBuroCrediticio) => {
  const resp = await post<IDataBuroCreditos>(`${urlBackend}api/v1/obtener-datos-buro-credito/`, data, true);
  return resp;
};
